import { CalculatorTabData } from '../../../../constants/partnerPageConst';
import { CorporatePage } from '../../../../types/partner-page-types';
import { GuidesAndUsefullLink } from '../../../Common/GuidesAndUsefullLink';
import { TabBarWithRender } from '../../../income-tax/page-sections/tabs/TabPanel';
import { getGuideCardsPerCollection } from '../../utils/utils';

export const TabSectionPartnerPage = ({
  postData,
}: {
  postData: CorporatePage;
}) => {
  return (
    <>
      <TabBarWithRender
        tabs={[
          {
            title: 'Calculator',
            id: 'calculator',
            render: () => (
              <GuidesAndUsefullLink
                heading={''}
                cards={CalculatorTabData.cards}
              />
            ),
          },
          {
            title: 'Guides',
            id: 'guides',
            render: () => (
              <GuidesAndUsefullLink
                heading={''}
                cards={getGuideCardsPerCollection(postData.collection)}
              />
            ),
          },
        ]}
        trackLabel={'calculator_and_useful_link_fold'}
      />
    </>
  );
};
